import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    public userList: Array<any>;
    public userPageMeta: any={
        pageNum: 1,
        pageSize: 20,
        pages: 0,
        total: 0,
    };
    public departmentQuery: any;
    public searchOptions: any;
    public filterOptions: any;
    public userListPageMeta: {
        pageSize: number;
        pageNum: number;
    } = {
        pageSize: 20,
        pageNum: 1
    };
    public selectedUsers: Array<any> = [];
    public isContactorView: boolean = false;
    public userInfo: any;
    public proCheckInfo;
    public descriptionMsg: string = '';
    public disabledModal: boolean = false;
    public disabledUserId: string = '';
    public disabledName: string = '';
    public refreshEdit: boolean = true;
    public isInnerUserControl: boolean = true;
    public securityMgr: any;
    public disabledUnlock: boolean = false;
    /** 全部的职位列表 */
    public jobList: Array<any>; 
    /** 选择用户的职位列表 */
    public selectedJob: Array<any>;
    public gUserId: string = '';
    activeKey: string = '1';
}



// WEBPACK FOOTER //
// ./src/display/platform/UserManage/Modules.State.ts